import { DetailedBet } from '@/models/detailed-bet';
import {
  QueryFetchType,
  usePaginatedOrInfiniteQuery,
  UseQueryProps,
} from '@starsoft/common/hooks';
import { useBetsByRoundDefault } from './default';
import { useBetsByRoundInfinite } from './infinite';
import { UseBetsByRoundProps } from './props';

export function useBetsByRound<
  T extends QueryFetchType,
  K extends UseBetsByRoundProps,
>({ type, enabled = true, ...rest }: UseQueryProps<T, K>) {
  return usePaginatedOrInfiniteQuery<T, DetailedBet[]>(
    { type, enabled, ...rest },
    useBetsByRoundInfinite,
    useBetsByRoundDefault,
  );
}
